import { stimulusApplication } from "web-ui/controllers"

// The action-notices stream action replaces only the action notices, leaving
// the page and form notices in place. It merges the incoming action notices
// together with the existing non-action notices, so merge sees the action
// notices as the only change: the existing page and form notices match
// themselves and stay put, while the action notices are replaced.
// See controllers/notices.js and controllers/notice.js.
function actionNotices() {
  const container = document.getElementById("notices")

  if (container == null) {
    return
  }

  const controller = stimulusApplication.getControllerForElementAndIdentifier(
    container,
    "notices"
  )

  if (controller == null) {
    return
  }

  const incoming = [...this.templateContent.querySelectorAll(".notice")]

  // Re-merging a notice that is mid-exit would re-insert it as an entrant
  // - Aaron, Wed Jun 10 2026
  const retained = [...container.querySelectorAll(".notice:not(.action):not(.exiting)")]

  // The stream action owns the action group, so an empty action section
  // clears the action notices - Aaron, Thu Jun 11 2026
  controller.merge([...incoming, ...retained], { replaceActions: true })
}

export function activate(Turbo) {
  Turbo.StreamActions.action_notices = actionNotices
}
